import { Injectable } from "@angular/core";
import { CreateWorkloadDto } from "../../../../data/repositories/agenda/entities/agenda.model";
import { AgendaRepository } from "../../../../domain/repositories/agenda.repositories";
import { GetUserRoleUseCase } from "../../../../domain/use-cases/agenda/get-role.usecase";
import { RetrieveAgendaUseCase } from "../../../../domain/use-cases/agenda/retrieve-agenda.usecase";
import { RetrieveWorkspaceUseCase } from "../../../../domain/use-cases/agenda/retrieve-workspace.usecase";

@Injectable({
  providedIn: "root",
})
export class AgendaService {
  constructor(
    private agendaRepo: AgendaRepository,
    private getUserRoleUseCase: GetUserRoleUseCase,
  ) {}

  retrieveAgendaList(rinaId: string) {
    const retrieveAgenda = new RetrieveAgendaUseCase(this.agendaRepo);
    return retrieveAgenda.execute(rinaId);
  }

  retrieveWorkspace(rinaId: string) {
    const retrieveWk = new RetrieveWorkspaceUseCase(this.agendaRepo);
    return retrieveWk.execute(rinaId);
  }

  // TODO: Use case is ready, implement it
  createWorkload(workload: CreateWorkloadDto) {
    return this.agendaRepo.createWorkloadDraft(workload);
  }

  // TODO: Use case is ready, implement it
  sendNotification(id: number) {
    return this.agendaRepo.sendNotification(id);
  }

  getUserRole(rinaId: string) {
    return this.getUserRoleUseCase.execute(rinaId);
  }
}
